import React from 'react'
import { IconButton } from 'shared/ui'

const SpamButton = React.memo(({ spamConversation, isExpired = false }) => {
  return (
    <div className="spam">
      <IconButton
        name="spam"
        size="medium"
        className="menu-button"
        disabled={isExpired}
        onClick={spamConversation}
        tooltip={
          !isExpired
            ? 'Mark as Spam [!]'
            : "Can't Mark as Spam an expired conversation"
        }
        svg
      />
    </div>
  )
})

export default SpamButton
